import React, { useState } from 'react';
import BehaviorForm from '../components/BehaviorForm';  // Assuming this is in components folder

const CustomBehaviors = () => {
  const [intrestData, setIntrestData] = useState([]);

  return (
    <div>
      <h1 className="text-xl font-bold mb-4">Submit New Behavior</h1>
      <BehaviorForm
        onSubmit={(newBehavior) => {
          setIntrestData((prev) => [...prev, newBehavior]);
        }}
      />
    </div>
  );
};

export default CustomBehaviors;
